<template>
  <v-card
    class="d-flex flex-column"
    flat
    tile
    :height="!isMobileBreakpoint ? 548 : '100dvh'"
  >
    <div class="w-full d-flex justify-space-between pa-6 pb-5">
      <div class="d-flex align-start">
        <v-btn icon width="24" height="24" @click="handleBack" class="mr-2">
          <v-icon class="neutral-70--text">mdi-arrow-left</v-icon>
        </v-btn>
      </div>
      <v-btn icon width="24" height="24" @click="handleClose">
        <v-icon class="neutral-70--text">mdi-close</v-icon>
      </v-btn>
    </div>

    <v-card-text style="overflow-y: auto;" class="flex-grow-1 px-7 py-0">

      <div
        class="d-flex flex-column"
        :class="{ 'mb-4': !isMobileBreakpoint, 'mb-7': isMobileBreakpoint }"
      >
        <span class="body-bold-medium neutral-20-dark--text mb-1">
          {{ $t('message.ai.dubbings.existingSubtitles.title') }}
        </span>
        <span class="body-regular-smaller neutral-40-light--text" style="max-width: 470px;">
          {{ $t('message.ai.dubbings.existingSubtitles.subtitle') }}
          <a
            target="_blank"
            size="xsmall"
            type="secondary"
            :href="$t('message.ai.dubbings.existingSubtitles.learnMoreHref')"
          >
            {{ $t('message.ai.dubbings.existingSubtitles.learnMore') }}
            <v-icon size="12">mdi-open-in-new</v-icon>
          </a>
        </span>
      </div>

      <div class="alert-box d-flex align-center mb-6">
        <span class="body-bold-small neutral-20-dark--text mr-3 mb-2">
          {{ $t('message.ai.dubbings.existingSubtitles.impactText') }}
        </span>
        <v-tag
          v-for="(lang, index) in languages"
          :key="lang.country"
          type="default"
          class="pa-1"
          :class="['mx-1', { 'ml-0': index === 0 }]"
        >
          <div class="d-flex align-center">
            <FlagCards :items="[lang.country]" />
            <span class="ml-2 body-bold-smaller brand-20-darkest--text">
              {{ lang.label }}
            </span>
          </div>
        </v-tag>
      </div>

      <v-radio-group v-model="replaceExistingSubtitles" class="mt-0 pt-0">
        <v-row
          v-for="option in options"
          :key="option.value"
          no-gutters
          class="option-container px-5 py-3"
          @click="replaceExistingSubtitles = option.value"
        >
          <v-col cols="auto" class="d-flex align-center">
            <v-radio :value="option.value"></v-radio>
          </v-col>
          <v-col class="flex-grow-1 d-flex flex-column align-start">
            <p class="body-regular-small neutral-20-dark--text mb-0">
              {{ $t(option.title) }}
            </p>
            <p class="body-regular-smaller neutral-40-light--text mb-0">
              {{ $t(option.description) }}
            </p>
          </v-col>
        </v-row>
      </v-radio-group>
    </v-card-text>

    <div class="card-actions">
      <div class="flex-grow-1 d-flex align-center">
        <a
          v-if="!isMobileBreakpoint"
          :href="$t('message.ai.dubbings.existingSubtitles.learnMoreHref')"
          target="_blank"
          class="body-bold-small primary--text"
          style="text-decoration: none;"
        >
          {{ $t('message.ai.dubbings.existingSubtitles.articleTitle') }}
          <v-icon size="12" class="brand-60-base--text">mdi-open-in-new</v-icon>
        </a>
      </div>
      <base-btn
        type="tertiary"
        @click="handleClose"
        :style="{ width: isMobileBreakpoint ? '50%' : 'auto' }"
      >
        {{ $t('message.actions.cancel') }}
      </base-btn>
      <base-btn
        class="ml-3"
        @click="handleConfirm"
        :style="{ width: isMobileBreakpoint ? '50%' : 'auto' }"
      >
        {{ $t('message.actions.confirm') }}
      </base-btn>
    </div>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import FlagCards from './FlagCards.vue'

export default {
  name: 'existingSubtitlesTemplate',
  components: {
    FlagCards,
  },
  props: {
    languages: {
      type: Array,
      default: () => [],
    },
    generateDubbingData: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    replaceExistingSubtitles: false,
    options: [
      {
        value: false,
        title: 'message.ai.dubbings.existingSubtitles.keepTitle',
        description: 'message.ai.dubbings.existingSubtitles.keepDescription',
      },
      {
        value: true,
        title: 'message.ai.dubbings.existingSubtitles.replaceTitle',
        description: 'message.ai.dubbings.existingSubtitles.replaceDescription',
      },
    ],
  }),
  computed: {
    ...mapState({
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
  },
  watch: {
    'generateDubbingData.replaceExistingSubtitles': {
      handler(val) {
        this.replaceExistingSubtitles = val
      },
      immediate: true,
    },
  },
  methods: {
    handleClose() {
      this.$root.$emit('closeDubbingModal')
    },
    handleBack() {
      this.$root.$emit('selectDubbingScreen')
    },
    handleConfirm() {
      this.$root.$emit('checkoutDubbingModal', {
        replaceExistingSubtitles: this.replaceExistingSubtitles,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.alert-box {
  background: varFigma(neutral-99);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  border-radius: 8px;
}
.language-tag {
  background: #e6e8fd;
  border-radius: 16px;
  padding: 2px 12px 2px 6px;
  font-weight: 700;
  font-size: 14px;
  color: #1a2341;
  display: inline-flex;
  align-items: center;
}
.option-container {
  cursor: pointer;
}
.card-actions {
  display: flex;
  justify-content: flex-end;
  padding: 28px;
  border-top: 1px solid varFigma(neutral-95-lightest);
  background: varFigma(neutral-100-white);
}
@media (max-width: 768px) {
  .card-actions {
    padding: 16px 20px;
  }
}
</style>